// contact-logging.js
document.addEventListener("DOMContentLoaded", function () {
  try {
    var contactInputs = document.querySelectorAll(
      'input[name="form_type"][value="contact"]'
    );
    if (!contactInputs.length) return;

    var attached = new WeakSet();

    contactInputs.forEach(function (input) {
      var form = input.form;
      if (!form || attached.has(form)) return;

      var action = (form.getAttribute("action") || "").toLowerCase();
      if (action && !action.includes("/contact")) return;

      attached.add(form);

      form.addEventListener("submit", function () {
        try {
          var nameEl = form.querySelector('input[name="contact[name]"]');
          var emailEl = form.querySelector('input[name="contact[email]"]');
          var messageEl = form.querySelector('textarea[name="contact[body]"]');
          var phoneEl = form.querySelector(
            'input[name^="contact[phone"], input[name^="contact[Phone"], input[id*="phone"]'
          );

          var payload = {
            name: nameEl ? nameEl.value.trim() : "",
            email: emailEl ? emailEl.value.trim() : "",
            message: messageEl ? messageEl.value.trim() : "",
            phone: phoneEl ? phoneEl.value.trim() : "",
            sourceUrl: window.location.href,
            site: "addex",
          };

          var extraFields = [];
          var allContactFields = form.querySelectorAll("[name^='contact[']");

          allContactFields.forEach(function (field) {
            var fieldName = field.getAttribute("name") || "";

            if (
              fieldName === "contact[name]" ||
              fieldName === "contact[email]" ||
              fieldName === "contact[body]" ||
              fieldName === "contact[Phone Number]" ||
              fieldName === "contact[phone]" ||
              fieldName === "contact[phone number]"
            ) {
              return;
            }

            var value = (field.value || "").trim();
            if (!value) return;

            var labelText = "";
            if (field.id) {
              var labelEl = form.querySelector('label[for="' + field.id + '"]');
              if (labelEl) {
                labelText = (labelEl.textContent || "").trim();
              }
            }

            if (!labelText) {
              labelText = fieldName
                .replace(/^contact\[/, "")
                .replace(/\]$/, "")
                .replace(/_/g, " ");
            }

            extraFields.push({
              key: fieldName,
              label: labelText,
              value: value,
            });
          });

          if (extraFields.length > 0) {
            payload.extraFields = extraFields;
          }

          fetch("/apps/toolbox/api/contact", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(payload),
            keepalive: true,
          }).catch(function (err) {
            console.warn("Addex contact logging fetch failed:", err);
          });
        } catch (err) {
          console.warn("Addex contact logging error:", err);
        }
      });
    });
  } catch (err) {
    console.warn("Addex contact logging init error:", err);
  }
});
